import {ButtonGroup, Chip, Divider, Grid, InputAdornment, NativeSelect} from "@mui/material";
import {
  displayDay,
  formatAge,
  formatCurrency,
  formatDate,
  formatDateMask,
  formatDateTime,
  isGuid,
  sortAttendeesFunction
} from "../../common/Utils";
import React, {useContext, useEffect, useRef, useState} from "react";
import MDButton from "../../../components/MDButton";
import Checkbox from "@mui/material/Checkbox";
import {getCustomerFamily, removeCartItem, removeMemberPerkItem, updateCartItem} from "../api/WebApi";
import {getCartFull, saveCustomerCartItemToTab, updateMemberBillingItem} from "../api/CartApi";
import {CalendarIcon, DesktopDatePicker} from "@mui/x-date-pickers";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ClearIcon from '@mui/icons-material/Clear';
import {Col, Row} from "react-bootstrap";
import MDInput from "../../../components/MDInput";
import isNumeric from "validator/es/lib/isNumeric";
import {
  AccessAlarm,
  AddCircleOutline,
  AllInclusive,
  MoreTime,
  PersonPin,
  RefreshOutlined,
  RemoveCircle
} from "@mui/icons-material";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleIcon from '@mui/icons-material/People';
import CartCafeGroupItems from "../../cart/CartCafeGroupItems";
import dayjs from "dayjs";
import EditIcon from "@mui/icons-material/Edit";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import MembershipPerks from "../../perks/MembershipPerks";
import PlaceIcon from '@mui/icons-material/Place';
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import InventoryGiftItem from "./InventoryGiftItem";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {useKiosk} from "../../../lib/KioskModeProvider";
import {CompanyContext} from "../../../lib/CompanyContext";
import LockedAccountForm from "../../form/LockedAccountForm";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import {CONSTANTS} from "../constants";

export default function CartItems({
                                    children,
                                    client,
                                    cart,
                                    getCartFullFn,
                                    callback,
                                    paymentMethod,
                                    familyMemberCallback,
                                    tipItem,
                                    giftItemCallback
                                  }) {
  const [renderIdx, setRenderIdx] = useState(1);
  const {putClient, clientCallback, toggleKioskMode} = useKiosk();
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [displayPaymentMethod, setDisplayPaymentMethod] = useState();
  useEffect(() => {
    setDisplayPaymentMethod(paymentMethod);
  }, [paymentMethod]);

  const applyProcessingFee = () => {
    if ('GIFT_CARD_PURCHASE' === cart?.checkoutDisposition) {
      return false;
    }
    return paymentMethod?.length > 0 && (paymentMethod === 'card' || paymentMethod === 'new' || paymentMethod === 'terminal' || isGuid(paymentMethod));
  }

  const doKiosk = () => {
    toggleKioskMode('last', true, client);
  }
  const deleteInventoryItem = async (item) => {
    removeCartItem(item).then((result) => {
      getCartFullFn();
    });
  };

  const removePerk = (item, perk) => {
    removeMemberPerkItem(client?.guid, perk.guid, item).then((resp) => {
      getCartFullFn()
    });
  }

  const matrixPrice = (item, attendeeId) => {
    const attendees = calculateAllAttendeePrices(item);

    const totalPrice = attendees.reduce(
      (sum, a) => sum + (a.calculatedPrice || 0),
      0
    );

    if (attendeeId) {
      return attendees.find(a => a.id === attendeeId)?.calculatedPrice || 0;
    }

    return totalPrice;
  };

  const calculateAllAttendeePrices = (item) => {
    const matrixMap = new Map();

    for (const attendee of item?.cartAttendees || []) {
      if (attendee.currentAttendee && attendee?.selectedAccount?.eventMatrixEntry) {
        const entry = attendee.selectedAccount.eventMatrixEntry;

        if (!matrixMap.has(entry.id)) {
          matrixMap.set(entry.id, []);
        }

        matrixMap.get(entry.id).push({attendee, entry});
      }
    }

    let complimentaryCount = 0;
    let compAttendees = [];
    let attendees = [];
    let infants = [];
    let siblings = new Map();
    let applyInfantDiscount = false;

    for (const attendee of item.cartAttendees || []) {
      attendee.calculatedPrice = 0;
      attendee.sibling = false;
      attendee.infant = false;
      attendee.hasChild = false;
    }

    for (const [, values] of matrixMap) {
      for (const {attendee, entry} of values) {
        const {
          price = 0,
          numComplimentary = 0,
          infant = false,
          discountAmount = 0,
          hasChild = true,
          id
        } = entry;

        attendee.hasChild = true;
        if (numComplimentary > 0) {
          complimentaryCount = numComplimentary;
          compAttendees.push({attendee, entry});
        } else if (infant) {
          attendee.infant = true;
          infants.push({attendee, entry});
        } else if (discountAmount > 0) {
          if (!siblings.has(id)) {
            siblings.set(id, []);
          }
          attendee.sibling = true;
          siblings.get(id).push({attendee, entry});
        } else {
          attendees.push({attendee, entry});
        }
      }
    }

    if (compAttendees.length >= complimentaryCount) {
      const toCharge = compAttendees.slice(complimentaryCount);
      for (const {attendee, entry} of toCharge) {
        attendee.calculatedPrice = entry.price;
      }
    }

    for (const [, values] of siblings) {
      applyInfantDiscount = true;

      values.forEach(({attendee, entry}, index) => {
        attendee.calculatedPrice =
          index === 0
            ? entry.price
            : entry.discountAmount;
      });
    }

    for (const {attendee, entry} of infants) {
      const explicitSiblingPass = attendee.selectedAccount?.siblingPass;
      if (explicitSiblingPass === true) {
        attendee.calculatedPrice = entry.discountAmount;
      } else if (explicitSiblingPass === false) {
        attendee.calculatedPrice = entry.price;
      } else if (applyInfantDiscount || hasOtherMembershipAttendee(attendee, item)) {
        attendee.calculatedPrice = entry.discountAmount;
      } else {
        attendee.calculatedPrice = entry.price;
      }
      applyInfantDiscount = true;
    }

    for (const {attendee, entry} of attendees) {
      attendee.calculatedPrice = entry.price;
    }

    return item.cartAttendees;
  };

  const [familyMembers, setFamilyMembers] = useState([]);
  useEffect(() => {
    if (!client || !client?.guid) {
      return;
    }
    getCustomerFamily(client?.guid).then((resp) => {
      setFamilyMembers(resp?.familyMembers);
    })
  }, [client]);

  const removeFamilyMembers = async (item) => {
    await getCartFull(client?.guid, 'MANAGE_ATTENDEES').then((resp) => {
      callback(resp);
    })
  }

  const removeFamilyMember = (item, member) => {
    let attendees = [];
    attendees.push(member);

    let attendeeDeleteRequest = {
      member: member,
      cartItem: {
        cartItemId: item.cartItemId,
        cartAttendees: attendees
      }
    }

    setRenderIdx(renderIdx + 1);

    familyMemberCallback(attendeeDeleteRequest);
  }

  const serviceCharge = () => {
    let amountDue = 0;
    if ('true' === companyContext?.company?.preferences['include_service_charge'] && applyProcessingFee()) {
      if (cart?.invoice) {
        amountDue = (parseFloat(0.03) * parseFloat(cart.invoice.amountDue - cart.invoice.calculatedTax));
      } else {
        amountDue = (parseFloat(0.03) * parseFloat(cart.itemsTotal));
      }

    }
    return amountDue;
  }

  const cartAmountDue = () => {
    let tipAmount = 0;
    if (tipItem?.tipAmount) {
      tipAmount = tipItem?.tipAmount;
    } else if (tipItem?.customTipAmount) {
      tipAmount = tipItem?.customTipAmount;
    }
    if (parseFloat(tipAmount) > 0) {
      return parseFloat(cart.amountDue) + parseFloat(tipAmount);
    }
    return parseFloat(cart.amountDue);
  }

  const updateCartAttendees = () => {
    let validCartAttendees = true;
    let items = [];
    cart?.items.map((_item) => {
      items.push(_item);
    });

    setMatrixErrors([]);

    items.map((_item, index) => {
      _item.validAttendees = true;

      let requireAdult = _item?.inventoryItem?.eventMatrix?.requireAdultAttendee;
      let requireChild = _item?.inventoryItem?.eventMatrix?.requireChildAttendee;

      let hasAdult = false;
      let hasChild = false;

      if (_item?.inventoryItem?.eventType?.requireAttendees) {
        if (!_item?.cartAttendees || _item?.cartAttendees?.length === 0) {
          _item.validAttendees = false;
        }
        let hasAttendee = false;
        let memberOnly = _item?.inventoryItem?.eventType?.memberOnly;
        if (memberOnly) {
          hasAttendee = true;
        }
        _item?.cartAttendees?.map((att, idx) => {
          if (memberOnly) {
            if (att.currentAttendee) {
              hasAttendee = hasAttendee && att.selectedAccount;
            }
          } else {
            if (att.currentAttendee && att.selectedAccount) {
              hasAttendee = true;
            }
          }

          if (hasAttendee && att.selectedAccount) {
            if (att.adult) {
              hasAdult = true;
            } else {
              hasChild = true;
            }
          }
        });
        _item.validAttendees = hasAttendee;
      }
      _item.requireAdult = requireAdult;
      _item.requireChild = requireChild;
      _item.hasAdult = hasAdult;
      _item.hasChild = hasChild;

      if (_item.requireAdult && !_item.hasAdult) {
        _item.validAttendees = false;
        setMatrixErrors((prev) => [...prev, 'Adult Attendee Required']);
      }
      if (_item.requireChild && !_item.hasChild) {
        _item.validAttendees = false;
        setMatrixErrors((prev) => [...prev, 'Child Attendee Required']);
      }
    });

    items.map((item, idx) => {
      validCartAttendees = validCartAttendees && item.validAttendees;
    });

    cart.validCartAttendees = validCartAttendees;
    callback(cart);
  }

  const updateFamilyMemberCartItem = (member, item) => {

    member.currentAttendee = !!!member.currentAttendee;
    if (!member.currentAttendee) {
      member.selectedAccount = null;
    }

    setRenderIdx(renderIdx + 1);
    populateRefs();

    updateCartAttendees();
  }

  const [accountsInUse, setAccountsInUse] = useState([]);
  const myRefs = useRef([]);

  const populateRefs = () => {
    for (let k in myRefs) {
      myRefs[k] = undefined;
    }
    let _accounts = [];

    for (let k in cart?.items) {
      for (let j in cart?.items[k]?.cartAttendees) {
        if (cart?.items[k].cartAttendees[j].selectedAccount) {
          let _target = cart?.items[k].cartAttendees[j].selectedAccount;
          let opt = cart?.items[k].cartItemId + '_' + _target.accountType?.memberAccountId + '_' + _target.id;
          if (_target.siblingPass) {
            opt = opt + '_s';
          }
          _accounts.push(opt);
          let cartItemAttendee = cart?.items[k].cartItemId + '_' + cart?.items[k].cartAttendees[j].id;
          myRefs[cartItemAttendee] = opt;
        }
      }
    }
    setAccountsInUse(_accounts);
  }
  useEffect(() => {
    populateRefs();
  }, [cart])

  const [renderIndex, setRenderIndex] = useState(1);

  const hasOtherMembershipAttendee = (m, item) => {
    return (item?.cartAttendees || []).some(
      (a) => a !== m && a.currentAttendee && a.selectedAccount && !a.selectedAccount.eventMatrixEntry
    );
  }

  const matrixEntryInUse = (at, m, item) => {
    if (at?.hasInfantDiscount) { // $15 first infant
      return calculateAllAttendeePrices(item).filter((a) => a.sibling)?.length > 0 || calculateAllAttendeePrices(item).filter((a) => a.infant)?.length > 0
    } else if (at?.infantDiscount) { // $5 infant discount, also unlocked by a sibling's Membership selection
      const pricedAttendees = calculateAllAttendeePrices(item);
      const hasPricedMatrixAttendee = pricedAttendees.filter((a) => a.hasChild)?.length > 0 || pricedAttendees.filter((a) => a.sibling)?.length > 0 || pricedAttendees.filter((a) => a.infant)?.length > 0;
      return !(hasPricedMatrixAttendee || hasOtherMembershipAttendee(m, item));
    } else if (at?.siblingEntry) {
      let opt = item.cartItemId + '_' + at?.siblingEntry;
      let _accounts = [...accountsInUse];
      let _count = _accounts.filter(x => x === opt).length;
      return _count > 0;
    }

    return false;
  }

  const checkInUse = (at, m, item) => {

    let opt = item.cartItemId + '_' + at.accountType?.memberAccountId + '_' + at.id;
    let _accounts = [...accountsInUse];

    if (at?.hasInfantDiscount || at?.infantDiscount) {
      return false;
    }
    if (at?.siblingDiscount) {
      if (at?.siblingPass) {
        let _count = _accounts.filter(x => x === opt).length;
        if (_count >= 1) {
          return false
        }
        return true;
      } else {
        let _count = _accounts.filter(x => x === opt).length;
        if (_count >= 1) {
          return true
        }
        return false;
      }
    }

    let accountPass = parseInt(at.id, 10).toString();
    if (at.siblingPass) {
      opt = opt + '_s';
      accountPass = accountPass + '_s';
    }
    if (at?.accountType?.familyPass) {
      if (at?.accountType?.unlimitedVisits) {
        return false;
      }
    }

    let myIndex = 0;
    let decrementVisits = at?.accountType?.decrementVisits;

    if (decrementVisits) {
      let decrementCounter = 0;
      _accounts.map((a, b) => {
        let _accountId = a.split('_');
        _accountId.splice(0, 1);
        let accountId = _accountId.join('_');
        if (accountPass === accountId) {
          decrementCounter++;
        }
      });
      return decrementCounter >= at?.accountType?.numberVisits;
    }

    if (at?.accountType?.numberVisits > 0) {
      myIndex = at?.accountType?.numberVisits - 1;
    }

    let count = _accounts.filter(x => x === opt).length;

    let inUse = count > myIndex;

    return inUse;
  }

  const handleChange = (e, m, item) => {

    if (parseInt(e.target.value, 10) === -1) {
      m.currentAttendee = false;
      m.selectedAccount = null;
    } else {
      m.currentAttendee = true;
    }

    for (let j in m.availableAccountTypes) {
      let at = m.availableAccountTypes[j];
      let account_id = item.cartItemId + '_' + at.accountType?.memberAccountId + '_' + at.id;
      if (at.siblingPass) {
        account_id = account_id + '_s';
      }
      if (account_id === e.target.value) {
        m.selectedAccount = m.availableAccountTypes[j];
      }
    }

    let cartItemAttendee = item.cartItemId + '_' + m.id;

    let opt = e.target.value;

    let _accounts = [...accountsInUse];
    if (myRefs[cartItemAttendee]) {
      _accounts.splice(accountsInUse.indexOf(myRefs[cartItemAttendee]), 1);
    }
    _accounts.push(opt);
    setAccountsInUse(_accounts);
    myRefs[cartItemAttendee] = opt;

    updateCartAttendees();
  }

  const accountTypeLabel = (member) => {
    let label = 'Attendee';
    if (member?.selectedAccount) {
      label = member?.selectedAccount?.name;
    }
    return <Chip variant="outlined"
                 color="secondary" label={label}/>;
  }

  const [showItemDiscount, setShowItemDiscount] = useState(false);
  const [discountItem, setDiscountItem] = useState();
  const [employeeDiscountAmount, setEmployeeDiscountAmount] = useState();
  const [employeeDiscountReason, setEmployeeDiscountReason] = useState();

  const toggleItemDiscount = (item) => {
    setDiscountItem(item);
    setShowItemDiscount(true);
    callback({
      action: 'discount'
    })
  }

  const moveCartItemToTab = (item) => {
    saveCustomerCartItemToTab(client, item).then((resp) => {
      getCartFullFn();
    });
  }

  const [itemRender, setItemRender] = useState(1);

  const removeItemDiscountItem = async (item) => {
    let _item = {...item};
    _item.employeeDiscountItem = null;
    updateCartItem(_item).then((resp) => {
      setShowItemDiscount(false);
      setItemRender(itemRender + 1);
      callback({
        action: 'setItemDiscount'
      })
      getCartFullFn();
    });
  }

  const applyItemDiscount = async (item) => {
    let _item = {...item};
    _item.employeeDiscountItem = {
      discountAmount: employeeDiscountAmount,
      discountReason: employeeDiscountReason
    }
    updateCartItem(_item).then((resp) => {
      setShowItemDiscount(false);
      setItemRender(itemRender + 1);
      callback({
        action: 'setItemDiscount'
      })
      getCartFullFn();
    });
  }

  const displayItemsTotal = (cart) => {
    let itemsNum = 0;
    for (let j in cart?.items) {
      itemsNum += (cart?.items[j]?.quantity > 0 ? cart.items[j].quantity : 1);
    }
    return itemsNum;
  }

  const [matrixErrors, setMatrixErrors] = useState([]);

  const getTotalDiscounts = (cart) => {
    let discountAmount = 0;
    for (let j in cart.items) {
      let amount = cart.items[j].employeeDiscountItem?.discountAmount;
      if (amount) {
        discountAmount += amount
      }
    }
    if (discountAmount <= 0) {
      return <></>
    }

    return <>
      <Divider/>
      <dt className={'col col-sm col-sm-6'}>
        Total Discounts:
      </dt>
      <dd className={'col col-sm col-sm-6 text-right'}>
        <b>{formatCurrency(discountAmount)}</b>
      </dd>
    </>

  }

  const updateMemberBillingItemFn = async (item, startDate) => {
    let _item = {...item};
    _item.memberStartDate = startDate;
    updateMemberBillingItem(_item).then((result) => {
      getCartFullFn();
    });
  };

  const [showMemberStartDate, setShowMemberStartDate] = useState([]);

  const toggleMemberStartDate = (item) => {
    let _memberStartDates = [];
    if (_memberStartDates[item?.cartItemId]) {
      _memberStartDates[item?.cartItemId] = !_memberStartDates[item?.cartItemId];
    } else {
      _memberStartDates[item?.cartItemId] = true;
    }
    setShowMemberStartDate(_memberStartDates);
  }

  const [savingItem, setSavingItem] = useState(false);

  const itemDiscountAmount = (item) => {
    let amount = 0;
    for (let dd in item.discountItems) {
      amount += item.discountItems[dd].discountAmount
    }
    return amount
  }

  const [openGiftItems, setOpenGiftItems] = useState({});
  const [giftItemsOpen, setGiftItemsOpen] = useState(false);

  useEffect(() => {
    setGiftItemsOpen(Object.entries(openGiftItems)?.filter(([id, isOpen]) => isOpen).length > 0)
  }, [openGiftItems]);

  const dynamicWidth = openGiftItems ? "75%" : "100%";

  const toggleGiftItems = (id, open) => {
    setOpenGiftItems(prev => ({...prev, [id]: !prev[id]}));
    giftItemCallback(open)
  };

  const giftableItem = (item) => {
    if (item?.inventoryItem?.accountType && !!!item?.inventoryItem?.accountType?.recurring) {
      return true;
    }
    return false;
  }

  const DepositItem = ({depositItem}) => {
    return (<div>
      <h6>Deposit Summary</h6>
      <p className={'mb-1'}>
        <b>Price:</b> {formatCurrency(depositItem?.packagePrice)}
      </p>
      {depositItem?.appliedDiscount > 0 && <>
        <p className={'mb-1'}>
          <b>Discount:</b> {formatCurrency(depositItem?.appliedDiscount)}
        </p>

        <p className={'mb-1'}>
          <b>Total:</b> {formatCurrency(depositItem?.packagePrice - depositItem?.appliedDiscount)}
        </p>
      </>}
      <p className={'mb-1'}>
        <b>Deposit:</b> {formatCurrency(depositItem?.depositAmount)}
      </p>

      <p className={'mb-1'}>
        <b>Balance Due:</b> {formatCurrency(depositItem?.balanceDue)}
      </p>
    </div>)
  }

  const DiscountItem = ({discountItem}) => {
    return (<div>
      {discountItem?.discountAmount > 0 && <>
        <p className={'mb-1'} style={{
          fontSize: '0.9rem'
        }}>
          <b>Discount:</b> {formatCurrency(discountItem?.discountAmount)}
        </p>
      </>}
    </div>)
  }

  const CartItemsCommon = () => {
    return <>
      {cart?.applyGiftCard && cart?.giftCardAmount > 0 &&
        <>
          <dt className={'col col-sm col-sm-6'}>
            Gift Card Amount:
          </dt>
          <dd className={'col col-sm col-sm-6 text-right'}>
            <b>{formatCurrency(cart.giftCardAmount)}</b>
          </dd>
        </>
      }
      {(tipItem?.tipAmount > 0 || tipItem?.customTipAmount > 0) && <>
        <dt className={'col col-sm col-sm-6 col-xs-12'}>
          Tip:
        </dt>
        <dd className={'col col-sm col-sm-6 text-right'}>
          <b>{formatCurrency(tipItem?.tipAmount || tipItem?.customTipAmount)}</b>
        </dd>
      </>
      }

      {'true' === companyContext?.company?.preferences['include_service_charge'] && applyProcessingFee() &&
        <>
          <Grid item sm={6} xs={6}>
            <dt className={'col col-sm col-sm-12 col-xs-12'}>
              Processing Fee:
            </dt>
          </Grid>
          <Grid item sm={6} xs={6}>
            <dd className={'col col-sm col-sm-12 col-xs-12 text-right'}>
              <b>{formatCurrency(serviceCharge())}</b>
            </dd>
          </Grid>
        </>
      }
    </>
  }

  return (
    <>
      {showItemDiscount && <Grid item xs={12}>
        <h5>
          Add Discount
        </h5>
        <dl className={'row'}>
          <dd className={'col col-sm col-sm-12'}>
            <b>{discountItem.inventoryItem.name}</b>
            <br/>
            <b>{formatCurrency(discountItem?.itemTotal)}</b>
            <p className={'my-0'}>
              {discountItem.inventoryItem?.eventType?.id && <>
                <small>
                  {formatDateTime(discountItem.inventoryItem.eventDate, 'hh:mm a')} - {formatDateTime(discountItem.inventoryItem.eventEndDate, 'hh:mm a')}
                  <br/>
                </small>
              </>
              }
            </p>
          </dd>
        </dl>
        <Row>
          <Col className={'col'} sm={6} xs={12}>
            <MDInput type="text" step="0.01" required
                     step={0.01}
                     onChange={(e) => {
                       let price = parseFloat(discountItem.itemTotal);
                       let v = e.target.value;
                       if (!v || !isNumeric(v)) {
                         setEmployeeDiscountAmount(null);
                         return;
                       }
                       if (parseFloat(v) > price) {
                         e.target.value = price;
                       }
                       setEmployeeDiscountAmount(parseFloat(e.target.value));
                     }}
                     InputProps={{
                       startAdornment: <InputAdornment position="start">
                         <span className={'fa fa-dollar'}></span>
                       </InputAdornment>,
                     }}
                     placeholder={"10.00"}
                     autoComplete="off"
                     className="form-control" id="minAmount"
                     label="Discount Amount"/>

            <MDInput style={{
              marginTop: '20px'
            }}
                     onChange={(e) => {
                       setEmployeeDiscountReason(e.target.value);
                     }}
                     type="text"
                     autoComplete="off" required
                     className="form-control" id={'itemDiscountReason-' + discountItem.guid}
                     label="Enter Discount Reason"/>
          </Col>
          <Col className={'col'} sm={12} style={{
            marginTop: '20px'
          }}>
            <MDButton
              style={{
                float: 'left'
              }}
              color="info"
              disabled={!employeeDiscountReason || !employeeDiscountAmount || parseFloat(employeeDiscountAmount) <= 0}
              onClick={() => {
                applyItemDiscount(discountItem)
              }}>
              Apply Discount
            </MDButton>

            <MDButton
              style={{
                float: 'right'
              }}
              color="primary"
              onClick={() => {
                callback({
                  action: 'setItemDiscount'
                })
                discountItem.employeeDiscount = null;
                setShowItemDiscount(false);
                setItemRender(itemRender + 1);
              }}>
              Cancel
            </MDButton>

          </Col>
        </Row>
      </Grid>}
      {!showItemDiscount && <>

        <Grid item xs={12}
              md={cart?.checkoutDisposition === 'REQUIRE_ATTENDEES' ||
              giftItemsOpen ? 12 : 6} p={1} sx={{
          flexBasis: dynamicWidth,
          maxWidth: dynamicWidth,
          transition: "flex-basis 0.4s ease, max-width 0.4s ease"
        }}>
          {cart && cart?.items
            .sort((a, b) => a.cartItemId - b.cartItemId)
            .filter((item) => {
              return cart?.checkoutDisposition !== 'REQUIRE_ATTENDEES' || (cart?.checkoutDisposition === 'REQUIRE_ATTENDEES' && item?.inventoryItem?.eventType?.requireAttendees)
            })
            .map((item, index) => {
              return (
                <Grid container key={index} className={'mb-4'}>
                  {giftItemsOpen && openGiftItems[index] && <>
                    <Grid item xs={12} className={' psb-carded '}>
                      <InventoryGiftItem cartItem={item} key={index}
                                         client={client}
                                         cancel={() => {
                                           toggleGiftItems(index)
                                         }}
                                         callback={(obj) => {
                                           toggleGiftItems(index);
                                           getCartFullFn();
                                         }}/>

                    </Grid>
                  </>
                  }
                  {!giftItemsOpen && !openGiftItems[index] && <>
                    <Grid item xs={12} className={' psb-carded '}>
                      <h5>
                        {!cart.invoiceCheckout && <>
                          <MDButton
                            circular
                            iconOnly
                            color="primary" size={'small'}
                            className={'pull-right'}
                            onClick={(e) => {
                              deleteInventoryItem(item)
                            }}>
                            <ClearIcon/>
                          </MDButton>
                        </>
                        }
                        {item?.inventoryItem?.selectedPackage &&
                          <>{item?.inventoryItem?.selectedPackage?.inventory?.name}&nbsp;</>
                        }
                        {item.inventoryItem.name}
                        {item?.quantity > 1 && <small>&nbsp; ({item.quantity})</small>}
                      </h5>
                      {item.inventoryItem?.eventType?.id && <>
                        <>
                          {item?.inventoryItem?.selectedPackage && item?.inventoryItem?.selectedPackage.assignedInventories?.filter(a => a.included).length > 0 &&
                            <span>
                            <p className={'mb-1'}><small><b>Party package includes:</b></small>&nbsp;
                              {item?.inventoryItem?.selectedPackage.assignedInventories?.filter(a => a.included).map((a, idx) => {
                                return (
                                  <small key={idx}>{idx === 0 ? '' : ', '}{a.name}</small>
                                )
                              })
                              }
                            </p>
                          </span>
                          }

                          {item?.inventoryItem?.selectedPackage?.packageAddOns?.length > 0 &&
                            <>
                            <span>
                              <p className={'mb-1'}><small><b>Add-Ons:</b></small>&nbsp;
                                {item?.inventoryItem?.selectedPackage.packageAddOns?.sort((a, b) => a.price > b.price ? -1 : 1)
                                  .map((a, idx) => {
                                    return (
                                      <small key={idx}>{idx > 0 && ', '}{a.name}</small>
                                    )
                                  })
                                }
                              </p>
                            </span>
                            </>
                          }


                          <p className={'mb-1'}>
                            <CalendarIcon/>&nbsp;
                            {displayDay(item.inventoryItem.eventDate, 'MM/DD/YYYY h:mm')} - {displayDay(item.inventoryItem.eventEndDate, 'h:mm a')}
                          </p>
                          {item.inventoryItem?.eventLocation?.name && <p className={'mb-1'}>
                            <PlaceIcon/>&nbsp;{item.inventoryItem?.eventLocation?.name}
                          </p>
                          }
                        </>

                        {cart?.checkoutDisposition !== 'REQUIRE_ATTENDEES' && item?.cartAttendees?.filter(member => member.currentAttendee).length > 0 &&
                          <span className={'mb-1'}>
                            <p className={'m-0'}><b><PeopleIcon/>&nbsp;
                              {item?.cartAttendees?.filter(member => member.currentAttendee).length === 1 ? 'Attendee' : 'Attendees'}&nbsp;
                            </b>
                          </p>
                            <table className={'mb-2'}>
                              <tbody>
                              {item?.cartAttendees?.sort(sortAttendeesFunction).filter(member => member.currentAttendee)
                                .map((m, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className={'px-2'}>{m.firstName} {m.lastName}</td>
                                      {item?.eventMatrix &&
                                        <td className={'px-2 text-right'}>
                                          {m?.selectedAccount?.eventMatrixEntry?.price > 0 && <>
                                          &nbsp;{formatCurrency(matrixPrice(item, m.id))}
                                        </>}&nbsp;
                                        </td>
                                      }
                                    </tr>
                                  )
                                })
                              }
                              </tbody>
                            </table>

                            <MDButton
                              variant="outlined"
                              color="secondary"
                              size="small"
                              circular
                              iconOnly
                              variant="outlined"
                              onClick={() => {
                                removeFamilyMembers(item)
                              }}
                              style={{
                                float: 'right'
                              }}><PersonPin/></MDButton>
                          </span>
                        }
                      </>
                      }

                      {!item?.depositItem && <>
                        {item?.itemTotal === 0 && item.itemPrice > 0 &&
                          <p className={'mb-1'}>Credit: {formatCurrency(item.itemPrice)}</p>}
                        {item?.inventoryItem?.eventMatrix != null && <>
                          <b>Price:</b> {formatCurrency(matrixPrice(item))}
                        </>
                        }

                        {item?.inventoryItem?.eventMatrix == null && !(cart?.invoice?.invoices?.length > 0) && <>
                          <p className={'mb-1'}>
                            <b>{cart?.invoice ? 'Amount Due:' : 'Price:'}</b> {formatCurrency(item.itemPrice)}
                          </p>
                        </>
                        }

                        {cart?.invoice?.invoices?.length > 0 && <>
                          <table className={'table'}>
                            <thead>
                            <tr>
                              <th>Name</th>
                              <th className={'text-right'}>Qty</th>
                              <th className={'text-right'}>Subtotal</th>
                              <th className={'text-right'}>Tax</th>
                              <th className={'text-right'}>Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            {cart?.invoice?.invoices?.map((inv, idx) => {
                              return (<tr className={'m-0'} key={idx}>
                                <td>{inv?.inventoryItem?.name}</td>
                                <td className={'text-right'}>{inv?.quantity}</td>
                                <td className={'text-right'}>{formatCurrency(inv?.amountDue - inv?.calculatedTax)}</td>
                                <td className={'text-right'}>{formatCurrency(inv?.calculatedTax)}</td>
                                <td className={'text-right'}>{formatCurrency(inv?.amountDue)}</td>
                              </tr>)
                            })
                            }
                            </tbody>
                          </table>
                        </>}

                        {item?.memberAccount && <p className={'mb-1'}>
                          <b>Membership:</b> {item?.memberAccount?.accountType?.name}
                        </p>
                        }

                      </>
                      }

                      <CartCafeGroupItems item={item}/>

                      {item?.inventoryItem?.accountType && <>
                        <dl className={'row'}>
                          {item?.inventoryItem?.accountType?.recurring &&
                            <>
                              <dd className={'col col-sm col-sm-12'}>
                                <small><RefreshOutlined/> Recurring
                                  {item?.inventoryItem?.accountType?.recurrencePattern === CONSTANTS.RECURRENCE_TYPES.TIME_BASED_RECURRING && ' every ' +
                                    item?.inventoryItem?.accountType.membershipTimeDays + ' Days'}</small>
                              </dd>
                              <dd className={'col col-sm col-sm-12'} style={{
                                display: !item?.inventoryItem?.minMembershipMonths || !item?.inventoryItem?.minimumCancellationDays ? 'none' : 'block'
                              }}>
                                <small><RemoveCircle/> Cancel at any time</small>
                              </dd>
                              {item?.inventoryItem?.minimumMembership &&
                                <dd className={'col col-sm col-sm-12'}>
                                  <small><LockPersonIcon/> Minimum {item?.inventoryItem?.minMembershipMonths} {item?.inventoryItem?.minMembershipMonths === 1 ? 'Month' : 'Months'}
                                  </small>
                                </dd>
                              }
                            </>
                          }
                          {item?.inventoryItem?.accountType?.recurring && <dd className={'col col-sm col-sm-12'}>
                            <small><EditCalendarIcon/> Membership Start Date:&nbsp;
                              {!showMemberStartDate[item?.cartItemId] && <><a href={'#'} onClick={(e) => {
                                e.preventDefault();
                                toggleMemberStartDate(item)
                              }}>{formatDate(item?.memberStartDate || new Date())}<EditIcon/></a> </>}

                            </small>
                            {showMemberStartDate[item?.cartItemId] && <>
                              <DesktopDatePicker
                                open={showMemberStartDate[item?.cartItemId]}
                                disabled={savingItem}
                                slotProps={{
                                  textField: {
                                    size: "small"
                                  },
                                  actionBar: {
                                    actions: ['today'],
                                  },
                                }}
                                value={dayjs(item?.memberStartDate || new Date())}
                                minDate={dayjs()}
                                onClose={() => {
                                  toggleMemberStartDate(item);
                                }}
                                onAccept={() => {
                                  toggleMemberStartDate(item);
                                }}
                                onChange={(e) => {
                                  setSavingItem(true)
                                  updateMemberBillingItemFn(item, new Date(e.$d)).then(() => {
                                    toggleMemberStartDate(item);
                                    setSavingItem(false);
                                  })
                                }}
                              />
                            </>}
                          </dd>
                          }

                          {item?.inventoryItem?.accountType?.unlimitedVisits &&
                            <dd className={'col col-sm col-sm-12'}>
                              <small><AllInclusive/> Unlimited Visits</small>
                            </dd>
                          }

                          {item?.inventoryItem?.accountType?.timeBased &&
                            <dd className={'col col-sm col-sm-12'}>
                              <small><AccessTimeIcon/> Expires in
                                Days {item?.inventoryItem?.accountType?.membershipTimeDays}</small>
                            </dd>
                          }

                          {item?.inventoryItem?.minimumCancellationDays &&
                            <dd className={'col col-sm col-sm-12'}>
                              <small><AccessAlarm/>&nbsp;{item?.inventoryItem?.minimumCancellationDays} {item?.inventoryItem?.minimumCancellationDays === 1 ? 'Day' : 'Days'} Cancellation
                                Notice</small>
                            </dd>
                          }

                        </dl>

                      </>}

                      <MembershipPerks inventory={item?.inventoryItem}/>

                      {item?.inventoryItem?.displayMembershipMembers?.length > 0 &&
                        <>
                          <p><small><b>Members:</b>&nbsp;
                            {item?.inventoryItem?.displayMembershipMembers.sort((a, b) => a.localeCompare(b)).join(', ')}
                          </small>
                            <br/>
                            <a className={'cursor-pointer'}
                               onClick={(e) => {
                                 let _cart = {...cart};
                                 _cart.checkoutDisposition = 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY'
                                 callback(_cart);
                               }}>
                              <small><EditIcon/> Edit Members</small>
                            </a>
                          </p>
                        </>
                      }
                      {renderIdx && cart?.checkoutDisposition === 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY'
                        && item?.inventoryItem?.membershipMembers?.length === 0 && <>

                          <LockedAccountForm inventory={item?.inventoryItem}
                                             client={client}
                                             callback={(cb) => {
                                               item.inventoryItem.membershipMembers = cb?.membershipMembers
                                             }}
                          />

                        </>}

                      {renderIdx && cart?.checkoutDisposition === 'REQUIRE_ATTENDEES'
                        && item?.inventoryItem?.eventType?.requireAttendees &&
                        <div>
                          {item.cartAttendees.length <= 0 &&
                            <p className="text-info">Update or add attendees for this event below</p>
                          }
                          {item?.inventoryItem?.eventType?.requireAttendees && <>
                            <div className={'table table-hover table-bordered'}>
                              <div>
                                {item?.cartAttendees?.sort(sortAttendeesFunction)?.map((m, index) => {
                                  return (<Grid container key={index} style={{
                                    border: 'solid 1px #ddd'
                                  }}>
                                    <Grid item sm={4} xs={12}>
                                      <label>
                                        <Checkbox
                                          checked={m.currentAttendee}
                                          onChange={() => {
                                            updateFamilyMemberCartItem(m, item)
                                          }}
                                          label={m.firstName + ' ' + m.lastName}
                                        />
                                        <span>{m.firstName} {m.lastName}&nbsp;
                                          {m?.familyMemberType === 1 && m?.dob && <>
                                            ({formatAge(m)})
                                          </>}
                                        </span>
                                      </label>
                                    </Grid>
                                    <Grid item sm={8} xs={12}>
                                      <NativeSelect
                                        // disabled={!m.currentAttendee}
                                        style={{
                                          float: 'left',
                                          width: '100%'
                                        }}
                                        onChange={(e) => {
                                          handleChange(e, m, item)
                                        }}
                                        value={myRefs[item.cartItemId + '_' + m.id] || -1}
                                        variant="outlined"
                                        name={'selectedAccount'} className={'form-control'}>
                                        <option value={-1} key={-1}>
                                          Choose Option
                                        </option>

                                        {m.selectedAccount?.defaultSelected && <option value={-10} key={-10}>
                                          {m.selectedAccount?.name}
                                        </option>
                                        }
                                        {m.availableAccountTypes.map((at, idx) => {
                                          return (
                                            <option
                                              disabled={renderIndex > 0 && (checkInUse(at, m, item) || matrixEntryInUse(at, m, item))}
                                              value={item.cartItemId + '_' + at?.accountType?.memberAccountId + '_' + at.id + (at.siblingPass ? '_s' : '')}
                                              key={idx}>{at.name}</option>
                                          )
                                        })}
                                      </NativeSelect>
                                    </Grid>
                                  </Grid>)
                                })}
                                <Grid container>

                                  {matrixErrors?.length > 0 &&
                                    <Grid item xs={12} justifyContent={'right'}>
                                      <p style={{
                                        textAlign: 'right'
                                      }}>
                                        {matrixErrors?.map((err, idx) => {
                                          return (<span key={idx} style={{
                                            marginRight: '4px',
                                            color: "#ff0000"
                                          }}>{err}.</span>)
                                        })}
                                      </p>
                                    </Grid>
                                  }

                                  <Grid item xs={12}>
                                  <span className={'pull-right'}>
                                    <MDButton
                                      variant="outlined"
                                      color="secondary"
                                      size="small"
                                      onClick={() => {
                                        let _cart = {...cart};
                                        _cart.checkoutDisposition = 'MANAGE_FAMILY_MEMBERS'
                                        callback(_cart);
                                      }}>
                                    <PersonAddIcon/>&nbsp;Add Family Member
                                  </MDButton>
                                </span>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </>}
                        </div>}

                      {renderIdx && cart?.checkoutDisposition !== 'REQUIRE_ATTENDEES' && <>
                        {item?.depositItem && <div className={'my-2'}>
                          <DepositItem depositItem={item.depositItem}/>
                        </div>
                        }
                        {item?.discountItem && <div className={'my-2'}>
                          <DiscountItem discountItem={item.discountItem}/>
                        </div>
                        }
                        {item.discountItems?.length > 0 && <>
                          {item.discountItems.map((discountItem, idx) => {
                            return (<div key={idx}>
                              <b>Discount:</b> ({discountItem.discountReason}) {formatCurrency(discountItem.discountAmount)}
                              {!discountItem?.locked && <>
                                <br/>
                                <a className={'cursor-pointer'}
                                   onClick={(e) => {
                                     removePerk(item, discountItem)
                                   }}>
                                  <small><RemoveCircle/> Remove Discount</small>
                                </a>
                              </>}
                            </div>)
                          })
                          }
                        </>
                        }

                        {item?.inventoryItem?.giftRecipient && <>
                          <p>
                            <small>Recipient: {item?.inventoryItem?.giftRecipient?.recipientName}</small><br/>
                            <small>Email: <u>{item?.inventoryItem?.giftRecipient?.email}</u></small><br/>
                            <small>Message:<br/><span style={{
                              whiteSpace: 'pre-wrap'
                            }}>{item?.inventoryItem?.giftRecipient?.message}</span>
                            </small>
                          </p>
                          {item?.inventoryItem?.giftRecipient?.deliverFuture && <p>
                            <small>
                              Scheduled to
                              send: {formatDateMask(item?.inventoryItem?.giftRecipient?.sendDate || new Date(), 'MM/DD/yyyy')}
                            </small>
                          </p>}
                        </>}

                        {giftableItem(item) && <>
                          <MDButton alt={"Click to send as gift"}
                                    className={'pull-right'}
                                    title={"Click to send as gift"}
                                    color="primary"
                                    variant="outlined"
                                    iconOnly={item?.inventoryItem?.giftRecipient && item?.inventoryItem?.giftRecipient?.recipientName?.length > 0}
                                    size="small"
                                    circular
                                    style={{
                                      fontSize: '11px',
                                      textTransform: 'inherit'
                                    }}
                                    onClick={() => {
                                      toggleGiftItems(index, true)
                                    }}>
                            <CardGiftcardIcon/>{!(item?.inventoryItem?.giftRecipient && item?.inventoryItem?.giftRecipient?.recipientName?.length > 0) && 'Send as gift?'}
                          </MDButton>

                        </>}

                      </>
                      }

                      {item.employeeDiscountItem &&
                        <div className={'d-block clear clearfix'}>
                          <p>
                            <small>
                              <a className={'pull-left cursor-pointer'}
                                 onClick={() => {
                                   removeItemDiscountItem(item);
                                 }}>
                                <HighlightOffIcon/>
                              </a>&nbsp;
                              <b>Discount:</b> {formatCurrency(item.employeeDiscountItem?.discountAmount)}
                              <br/>&nbsp;&nbsp;&nbsp;&nbsp;<b>Reason:</b> {item.employeeDiscountItem?.discountReason}
                            </small>
                          </p>
                        </div>
                      }
                      {!item?.depositItem && !cart.invoiceCheckout && cart?.checkoutDisposition !== 'REQUIRE_ATTENDEES' && <>
                        {!item.employeeDiscountItem && item?.itemTotal > 0 && <div className={'d-block clear clearfix'}>
                          <small>
                            <ButtonGroup className={'mt-2'}>
                              <MDButton
                                color="primary"
                                variant={'outlined'} size={'small'}
                                onClick={() => {
                                  toggleItemDiscount(item);
                                }}><AddCircleOutline/>&nbsp;Add Discount
                              </MDButton>
                            </ButtonGroup>
                          </small>
                        </div>
                        }
                        {client && <span className={'pull-right'}>
                          <MDButton
                            alt={'Send to Tab'}
                            title={'Send to Tab'}
                            iconOnly={true}
                            circular={true}
                            color="secondary"
                            size={'small'}
                            onClick={() => {
                              moveCartItemToTab(item)
                            }}><MoreTime/>
                              </MDButton>
                        </span>}
                      </>
                      }

                    </Grid>
                  </>
                  }
                </Grid>
              )
            })
          }
          <MDButton
            onClick={(e) => {
              callback({action: 'close'})
              const timeOutId = setTimeout(() =>
                doKiosk(), 100);
              return () => clearTimeout(timeOutId);
            }}
            color={'primary'}
            variant={'outlined'}
            iconOnly
            circular
            style={{
              position: 'absolute',
              bottom: '10px',
              left: '6px',
              marginRight: '2px',
              marginLeft: '8px',
              borderColor: '#ddd',
              color: '#111',
              background: '#fff'
            }}>
            <StorefrontIcon/>
          </MDButton>
        </Grid>


        {!giftItemsOpen &&
          cart?.checkoutDisposition !== 'REQUIRE_ATTENDEES' &&
          <Grid item xs={12} md={6} p={2} style={{
            position: 'relative',
          }}>
            <div style={{
              position: 'sticky',
              top: 0
            }}>
              {cart?.invoice && <>
                <dl className={'row'}>
                  <dt className={'col col-sm col-sm-6'}>
                    Invoice Total:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    {formatCurrency(cart.invoice.originalAmount)}
                  </dd>
                  {cart.invoice?.totalDiscounts > 0 && <>
                    <dt className={'col col-sm col-sm-6'}>
                      Discounts:
                    </dt>
                    <dd className={'col col-sm col-sm-6 text-right'}>
                      ({formatCurrency(cart.invoice.totalDiscounts)})
                    </dd>
                  </>}
                  <dt className={'col col-sm col-sm-6'}>
                    Tax:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    {formatCurrency(cart.invoice.calculatedTax + cart.invoice.depositedTax)}
                  </dd>
                  <dt className={'col col-sm col-sm-6'}>
                    Grand Total:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    {formatCurrency(cart.invoice?.depositedAmount + cart.invoice?.subtotal + cart.invoice.calculatedTax)}
                  </dd>

                  {cart.invoice?.depositedAmount > 0 &&
                    <>
                      <dt className={'col col-sm col-sm-6'}>
                        Payments:
                      </dt>
                      <dd className={'col col-sm col-sm-6 text-right'}>
                        <b>({formatCurrency(cart.invoice?.depositedAmount)})</b>
                      </dd>
                    </>}

                  <CartItemsCommon/>

                  <dt className={'col col-sm col-sm-6'}>
                    Total Due:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    {formatCurrency(cartAmountDue() + serviceCharge())}
                  </dd>
                </dl>
              </>
              }

              {!cart?.invoice && <>
                <dl className={'row'}>

                  <dt className={'col col-sm col-sm-6'}>
                    Items ({displayItemsTotal(cart)}) Total:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    {formatCurrency(cart.itemsTotal)}
                  </dd>
                  {cart?.appliedDiscountAmount > 0 && <>
                    <dt className={'col col-sm col-sm-6'}>
                      Applied Credit:
                    </dt>
                    <dd className={'col col-sm col-sm-6 text-right'}>
                      {formatCurrency(cart.appliedDiscountAmount)}
                    </dd>
                  </>}
                  <dt className={'col col-sm col-sm-6'}>
                    Sales Tax:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    {formatCurrency(cart.totalTax)}
                  </dd>
                  <dt className={'col col-sm col-sm-6'}>
                    Cart Total:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    {formatCurrency(cart.cartTotal)}
                  </dd>

                  <CartItemsCommon/>

                  <dt className={'col col-sm col-sm-6'}>
                    Total Due:
                  </dt>
                  <dd className={'col col-sm col-sm-6 text-right'}>
                    <b>{formatCurrency(cartAmountDue() + serviceCharge())}</b>
                  </dd>
                </dl>
              </>
              }

              {children}

            </div>

          </Grid>
        }
      </>
      }
    </>
  )
}